document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("add-product-checkbox");
  const additionalProductId = "41339022934098"; // ID de la variante válida
  const quantity = 1;

  checkbox.addEventListener("change", function () {
    if (checkbox.checked) {
      // Agregar el producto al carrito
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: additionalProductId,
          quantity: quantity,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Error al agregar el producto");
          }
          return response.json();
        })
        .then(() => {
          alert("¡Producto agregado al carrito exitosamente! 🎉");

          // Actualizar la visualización del carrito
          updateCart();
          updateCartAJAX(); // Actualizamos también el carrito AJAX
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("Hubo un problema al agregar el producto al carrito.");
        });
    }
  });

  function updateCart() {
    // Llamar a la API de carrito de Shopify para obtener el carrito actualizado
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCount = document.getElementById("cart-count");
        if (cartCount) {
          cartCount.textContent = cart.item_count; // Muestra el número de productos en el carrito
        }

        const cartTotal = document.getElementById("cart-total");
        if (cartTotal) {
          cartTotal.textContent = `$${cart.total_price / 100}`; // Muestra el total en el carrito
        }
      })
      .catch((error) => {
        console.error("Error al actualizar el carrito:", error);
      });
  }

  function updateCartAJAX() {
    // Este es el paso donde se actualiza el carrito AJAX (popup o barra lateral)
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // Aquí debes refrescar el contenido del carrito AJAX. Este es un ejemplo:
        const cartPopup = document.getElementById("cart-popup"); // Asegúrate de tener un ID correcto
        if (cartPopup) {
          // Refresca el contenido del carrito en el popup
          cartPopup.innerHTML = ""; // Limpiar el contenido actual
          cart.items.forEach((item) => {
            const itemElement = document.createElement("div");
            itemElement.innerHTML = `
              <div class="cart-item">
                <span>${item.quantity} x ${item.title}</span>
                <span>$${(item.line_price / 100).toFixed(2)}</span>
              </div>
            `;
            cartPopup.appendChild(itemElement);
          });
        }
      })
      .catch((error) => {
        console.error("Error al actualizar el carrito AJAX:", error);
      });
  }
});
